import { takeLatest, all, put } from 'redux-saga/effects';
import Actions from "../action";
import { doGet } from '../../service/index';
import END_POINTS from './EndPoints';
import { QR_ACCESS_LIST } from '../action/QrAccessAction';

export function* qrAccessListSaga({ params, callback }) {
    try {
        const response = yield doGet(END_POINTS.QR_ACCESS_LIST, params)
        yield put(Actions.qrAccessListSuccess(response));
        if (callback) {
            callback(response)
        }
    } catch (error) {
        yield put(Actions.qrAccessListFailure({ error }));
        if (callback) {
            callback(error)
        }
    }
}



export default function* qrAccessListWatcher() {
    yield all([
        takeLatest(QR_ACCESS_LIST, qrAccessListSaga),

    ]);
}